<template>
  <div class="help">
    <help-header></help-header>

    <div :style="{height: clientHeight - 60 + 'px'}">
      <side-bar
        style="float: left"
        :menus="types"
        :currIndex="currTypeIndex"
        :changeMenu="changeTypeIndex">
      </side-bar>
    
      <div class="main" ref="main">
        <help-search v-model.trim="searchKey"></help-search>

        <help-card
          v-if="searchKey !== ''"
          style="margin: 30px auto;"
          title="搜索结果"
          :selectItem="selectQuestion"
          :list="searchResult">
            <p>很抱歉，没有找到“<span style="color: red">{{searchKey}}</span>”相关的问题。</p>
            <p>您可以尝试搜索别的关键词，或者<a href="javascript: void(0);" @click="init()" style="color: #457EEC; text-decoration: underline;">返回帮助首页</a></p>
        </help-card>

        <!-- 问题列表 -->
        <help-card
          v-else-if="currQuestionIndex === -1"
          style="margin: 30px auto;"
          :title="types[currTypeIndex].type"
          :selectItem="selectQuestion"
          :list="questions">
        </help-card>
        <!-- /问题列表 -->

        <!-- 问题详情 -->
        <div v-else-if="question !== null" class="wrap-question" @click="proxyClick">
          <p class="question-title">{{question.question}}</p>
          <div v-html="question.answer" class="wrap-answer"></div>
        </div>
        <!-- /问题详情 -->
      </div>
    </div>

  </div>
</template>

<script>
import HelpHeader from '@/page/help/components/header'
import SideBar from '@/page/help/components/sidebar'
import HelpSearch from '@/page/help/components/search'
import HelpCard from '@/page/help/components/card'

import { types, questions } from '@/page/help/questions-json'

export default {
  components: {
    HelpHeader,
    SideBar,
    HelpSearch,
    HelpCard
  },
  data () {
    return {
      clientHeight: document.documentElement.clientHeight,
      types,
      currTypeIndex: 0,
      currQuestionIndex: -1,
      searchKey: ''
    }
  },
  computed: {
    questions: function () {
      const index = this.currTypeIndex
      return types[index].questions.map(item => questions[item])
    },
    question: function () {
      const index = this.currQuestionIndex
      if (index !== -1) {
        return questions[index]
      }
      return null
    },
    searchResult: function () {
      const searchKey = this.searchKey.toLowerCase()
      const reg = new RegExp(searchKey, 'ig')
      if (searchKey) {
        const questionsList = questions.filter(item => item.question.toLowerCase().indexOf(searchKey) >= 0)
                                .map(item => {
                                  item = {
                                    question: item.question.replace(reg, `<span style="color:red">$&</span>`),
                                    answer: item.answer,
                                    index: item.index
                                  }
                                  return item
                                })
        return questionsList
      }
      return []
    }
  },
  methods: {
    changeTypeIndex (index) {
      this.$refs.main.scrollTop = 0
      this.searchKey = ''
      this.currQuestionIndex = -1
      this.currTypeIndex = index
    },
    selectQuestion (index) {
      this.$refs.main.scrollTop = 0
      this.searchKey = ''
      this.currQuestionIndex = index
      const types = this.types
      const currQuestionIndex = this.currQuestionIndex
      if (types[this.currTypeIndex].questions.indexOf(currQuestionIndex) === -1) {
        for (let i = 0, len = types.length; i < len; i++) {
          if (types[i].questions.indexOf(currQuestionIndex) >= 0) {
            this.currTypeIndex = i
            return
          }
        }
      }
    },
    init () {
      this.searchKey = ''
      this.currTypeIndex = 0
      this.currQuestionIndex = -1
    },
    proxyClick (event) {
      const target = event.target
      if (target.tagName.toLowerCase() === 'img') {
        if (target.className === 'active') {
          target.className = ''
        } else {
          target.className = 'active'
        }
      }
    }
  },
  mounted () {
    document.title = '搜狐邮箱帮助中心'
    window.addEventListener('resize', () => {
      this.clientHeight = document.documentElement.clientHeight
    })
  }
}
</script>

<style lang="scss" scoped>
  .help {
    color: #000;
  }

  .main {
    padding: 30px 0;
    height: 100%;
    overflow: auto;
  }

  .wrap-question {
    margin: 30px auto 0;
    width: 830px;
  }

  .wrap-answer /deep/ p {
    margin: 20px;
    line-height: 24px;
    font-size: 14px;
  }

  .wrap-answer /deep/ img {
    margin-left: 10px;
  }

  .wrap-answer /deep/ img.active {
    width: 770px;
  }

  .wrap-answer /deep/ a {
    color: #457EEC;
  }

  p.question-title {
    font-size: 20px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/page/help/help.vue